import { ACT_STATS_CHANGE } from "../actions/ActionTypes";

const initialState = {
  statsByClient:[]
};

export default function(state = initialState, action) {
	if (action.type === ACT_STATS_CHANGE) {
		return Object.assign({}, state, action.props);
	}
	return state;
}



// WEBPACK FOOTER //
// ./src/reducers/StatsReducer.js